/** Forward message — new outbound event with forward flag (H4). */

import { VetoError } from "./errors";
import type { MessageEvent } from "./index";

function createEventId(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function buildForwardedMessage(input: {
  source: MessageEvent;
  targetConversationId: string;
  senderDevice: string;
}): MessageEvent {
  if (input.source.viewOnce) {
    throw new VetoError("PERMISSION_DENIED", "View-once messages cannot be forwarded");
  }
  const body = input.source.deletedForEveryone
    ? "[Forwarded: original deleted]"
    : input.source.body;
  return {
    eventId: createEventId(),
    conversationId: input.targetConversationId,
    senderDevice: input.senderDevice,
    direction: "out",
    body: `↪ ${body}`,
    logicalCounter: Date.now(),
    createdAt: Date.now(),
    status: "queued",
    contentType: input.source.contentType,
  };
}

export function isForwardedBody(body: string): boolean {
  return body.startsWith("↪ ");
}
